import React, { useEffect, useState } from "react";
import { TextInput, SelectInput, DateInput } from "../../Components/Inputs";
import init_records from "../init_records";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";
import SearchableSelect from "../../Components/Inputs/SearchableSelect";
import useApp from "../../../../Hooks/useApp";

const Edit = () => {
  const [input, setInput] = useState(init_records);
  const [vehicles, setVehicles] = useState({});
  const [loading, setLoading] = useState(true);
  const { user } = useApp();
  const navigate = useNavigate();
  const { id } = useParams();
  const request = useAxios();

  // Fetch data on mount
  useEffect(() => {
    const init = async () => {
      await getFuelRecord();
      await getVehicles();
      setLoading(false);
    };
    init();
  }, []);

  // Fetch single fuel record
  const getFuelRecord = async () => {
    let res = await request({ method: "GET", url: `fuel/${id}` });
    if (res !== "error") {
      console.log("Fuel record fetched:", res);
      setInput(res);
    }
  };

  // Fetch vehicle options
  const getVehicles = async () => {
    let res = await request({
      method: "GET",
      url: "Vehicles/search-vehicle",
      show_loading: false,
      show_error: false,
    });
    if (res !== "error" && res?.docs) {
      setVehicles(res);
    }
  };

  // Auto-calculate cost when amount or price changes
  useEffect(() => {
    const fuelAmount = parseFloat(input.fuel_amount || 0);
    const pricePerLitre = parseFloat(input.price_per_litre || 0);
    const calculatedCost = (fuelAmount * pricePerLitre).toFixed(2);

    setInput((prev) => ({
      ...prev,
      cost: calculatedCost,
    }));
  }, [input.fuel_amount, input.price_per_litre]);

  // Update fuel record
  const handleUpdate = async (data) => {
    console.log("Submitting update:", data);
    let res = await request({
      method: "PUT",
      url: `fuel/${id}`,
      body: data,
    });
    if (res === "error") {
      alert("Failed to update record.");
      return;
    }
    navigate("/dashboard/fuel");
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleUpdate,
  });

  if (loading) return <div className="text-center mt-20">Loading...</div>;

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12">
      <h3 className="text-center text-xl font-semibold">Edit Fuel Record</h3>

      <div className="mt-4">
        {/* Row 1 */}
        <div className="flex gap-5 items-center max-md:flex-col">
          <DateInput
            input={input}
            setInput={setInput}
            field="fuel_date"
            validate={validate}
            label="Fuel Date"
          />
          <SearchableSelect
            input={input}
            setInput={setInput}
            field="vehicle_id"
            validate={validate}
            url="Vehicles/search-vehicle"
            setOption={setVehicles}
          >
            {vehicles?.docs?.length ? (
              vehicles.docs.map((vehicle, i) => (
                <option value={vehicle?.id} key={i} label={vehicle.plate_no}>
                  {vehicle?.plate_no}
                </option>
              ))
            ) : (
              <option disabled>No vehicles found</option>
            )}
          </SearchableSelect>
        </div>

        {/* Row 2 */}
        <div className="flex gap-5 items-center max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="fueled_by"
            validate={validate}
            label="Fueled By"
          />
          <TextInput
            input={input}
            setInput={setInput}
            field="trip_id"
            validate={validate}
            label="Trip"
          />
        </div>

        {/* Row 3 */}
        <div className="flex gap-5 items-center max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="fuel_amount"
            validate={validate}
            label="Fuel Amount (Litres)"
            type="number"
          />
          <TextInput
            input={input}
            setInput={setInput}
            field="price_per_litre"
            validate={validate}
            label="Price Per Litre"
            type="number"
          />
        </div>

        {/* Row 4 */}
        <div className="flex gap-5 items-center max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="cost"
            validate={validate}
            label="Total Cost"
            type="number"
            disabled={true}
          />
          <TextInput
            input={input}
            setInput={setInput}
            field="filling_station"
            validate={validate}
            label="Filling Station"
          />
        </div>

        {/* Row 5 */}
        <div className="flex gap-5 items-center max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="nano_receipt"
            validate={validate}
            label="Receipt"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-4 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/fuel")}>Back</Btn>
        <Btn onClick={handleValidation}>Update</Btn>
      </div>
    </div>
  );
};

export default Edit;
